/**
 * Common Service
 */
class CommonServiceClass {
    /**
     * Method to generate hash code
     * @param payload
     * @memberof CommonServiceClass
     */
    generateHashCode(payload: string) {
        /* tslint:disable:no-bitwise */
        /* tslint:disable:quotemark */
        const key = payload.toLowerCase().split("").reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a; }, 0);
        /* tslint:enable:quotemark */
        /* tslint:enable:no-bitwise */
        return key;
    }
}

export const CommonService = new CommonServiceClass();
